import React, { useState } from "react";
import "./feedback.css";
import failLogo from "../../assets/fail-logo.svg";
import successLogo from "../../assets/success-icon.svg";
import warningLogo from "../../assets/warning-logo.png";
import agreementLogo from "../../assets/agreement-logo.png";
import CookiesServices from "../../services/CookiesService";

const cookiesServices = new CookiesServices();

export default function Feedback({
  message,
  type,
  onClose,
  keepOpen = false,
}) {
  const [showFeedback, setShowFeedback] = useState(true);

  const handleClose = () => {
    if (!keepOpen) {
      setShowFeedback(false);
    }

    if (onClose) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return successLogo;

      case "warning":
        return warningLogo;

      case "expire":
        return warningLogo;

      case "agreement":
        return agreementLogo;

      default:
        return failLogo;
    }
  };

  const getPopupClass = () => {
    switch (type) {
      case 'success':
        return 'feedback-popup success';

      case 'warning':
        return 'feedback-popup warning';

      case 'expire':
        return 'feedback-popup expire';

      case 'agreement':
        return 'feedback-popup agreement';

      default:
        return 'feedback-popup error';
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case 'success':
        return 'ok-button success-btn';
      case 'warning':
        return 'ok-button warning-btn';
      case 'expire':
        return 'login-button expire-btn';

      case 'agreement':
        return 'agreement-btn';

      default:
        return 'ok-button error-btn';
    }
  };

  return (
    showFeedback && (
      <div className={getPopupClass()}>
        <div className="feedback-content">
          <div className="feedback-status">
            <img
              src={getIcon()}
              alt={type}
              className="feedback-icon"
            />

            <div className="feedback-message">
              {message}
            </div>

            {type === "expire" ? (
              <button
                className={getButtonClass()}
                onClick={() => {
                  cookiesServices.clearLogin();
                  window.location.href =
                    `${process.env.REACT_APP_LOGIN_URL}`;
                }}
              >
                Login
              </button>
            ) : (
              <button
                className={getButtonClass()}
                onClick={handleClose}
              >
                OK
              </button>
            )}
          </div>
        </div>
      </div>
    )
  );
}
